/**
 * obtenemos un valor y foltramos los caracteres permitiendo
 * solo aquellos prensentes en la expresion regular
 *
 * @param {ValidateFormCharacterProps} { fieldValue }
 * @return {*}  {string}
 */
export const handleValidateFormCharacter = ({ fieldValue }) => {
    return fieldValue
        .toString()
        .replace(/[^ !"#$%&/()=?¡¿'*{}[\]\-_.:,<>|°^`~¬@a-zA-Z0-9\sáéíóúÁÉÍÓÚüÜäëïöÄËÏÖñÑ\n]/g, '');
};
